import { render } from "./Editor.vue?vue&type=template&id=10d8ec97"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"

import "./Editor.vue?vue&type=style&index=0&id=10d8ec97&lang=css"
script.render = render

export default script